import POLICIES from '../security/policies';

export default {
  path: '/sign-up',
  component: () => import('@/vue-app/views/SignUp.vue'),
  meta: {
    access_policy: POLICIES.UNAUTHENTICATED,
  },
};
